import jwt from 'jsonwebtoken';
import {forEach} from 'lodash';
import {scroller} from 'vue-scrollto/src/scrollTo'

/* When update buefy to v0.7, remove utilsVue and use
* import { Toast } from 'buefy/dist/components/toast'
* Toast.open('Toasty!') */
const MIN_PHONE_LENGTH = 10;

let utilsVue = null;

function scrollToAnchor(store) {
  setTimeout(() => {
    const previousAnchor = store.getters.previousAnchorState;
    if (previousAnchor) {
      const previousAnchorOffset = store.getters.previousAnchorStateOffset;

      const element = document.getElementById(previousAnchor);
      if (element) {
        scroller()(element, 300, {
          easing: [0.6, 0, 0.3, 1],
          offset: previousAnchorOffset || -5
        });
        store.commit('mutatePreviousAnchorState', null);
        store.commit('mutatePreviousAnchorStateOffset', null);
      }
    }
  }, 0);
}

export default {
  createToken(account, secret) {
    var uuid = require('uuid');
    var token = jwt.sign(
      {
        id: uuid(),
        exp: Math.floor(Date.now() / 1000) + 60 * 10,
        account: account
      },
      secret
    );
    return token;
  },
  setInLocalStorageIfEmpty(key, value) {
    if (localStorage.getItem(key) === null && value) {
      localStorage.setItem(key, value);
    }
  },
  setValueToCookie(key, value, path) {
    if (value) {
      document.cookie = key + '=' + value + ';path=' + (path || '/');
    }
  },
  getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },
  queryStringToDict(queryString) {
    if (!queryString) {
      return {};
    }
    if (queryString[0] === '?') {
      queryString = queryString.substr(1);
    }
    const parts = queryString.split('&');
    let dict = {};
    parts.forEach(part => {
      const keyValue = part.split('=');
      dict[keyValue[0]] = decodeURIComponent(keyValue[1]);
    });
    return dict;
  },
  dictToQueryString(params) {
    return Object.keys(params)
      .reduce(function(a, k) {
        a.push(k + '=' + encodeURIComponent(params[k]));
        return a;
      }, [])
      .join('&');
  },
  getErrorsFromResponse(response) {
    let errorsList = {};
    let errors = response.data.errors;

    if (!errors) {
      errors = response.data;
    }

    for (let field in errors) {
      if (!errors.hasOwnProperty(field)) {
        continue;
      }
      if (errors[field]) {
        errorsList[field.replace(/_/g, ' ')] = errors[field].join(' ');
      }
    }

    return errorsList;
  },
  getErrorMessageFromResponse(response) {
    let errorsList = [];
    let errors = response.data.errors;

    if (!errors) {
      return response.data;
    }

    for (let field in errors) {
      if (!errors.hasOwnProperty(field)) {
        continue;
      }
      if (errors[field]) {
        errorsList.push(errors[field].join(', '));
      }
    }

    return errorsList.join(', ');
  },
  setVueForUtils(vue) {
    utilsVue = vue;
  },
  showErrorToast(error, onStatus = 500) {
    if (error.response && error.response.status) {
      if (!utilsVue || error.response.status !== onStatus) {
        throw error;
      }
      let errors = [];
      forEach(error.response.data.errors, value => {
        errors.push(value[0]);
      });
      for (let error of errors) {
        utilsVue.$toast.open({duration: 5000, message: error, position: 'is-bottom', type: 'is-danger'});
      }
    }
    console.error(error);
  },
  parsePayloadFromJWT(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    return this.base64ToObject(base64);
  },
  base64ToObject(base64) {
    return JSON.parse(window.atob(base64));
  },
  isUrlOpen(url) {
    let openPaths = ['/jobs/'];

    if (url.includes('/accounts')) {
      return !url.includes('/accounts/settings') && !url.includes('/accounts/change-password');
    }

    for (let openPath of openPaths) {
      if (url.includes(openPath)) {
        return true;
      }
    }
    return false;
  },
  modifyFormatForChinese(format) {
    /* The moment has bug, it's not adding `日` symbol an the end of `D` format */
    if (format.includes('DDD')) return format;
    const reg = /([^D]*)(D{1,2}(?![Do]))/;
    return format.replace(reg, '$1Do');
  },
  afterEachRouteScroll(to, from, router, store) {
    if (to.path !== from.path) {
      scroller()({x: 0, y: 0});
      if (!router.app.$browserDetermine.isIE11()) {
        scrollToAnchor(store);
      }
    }
  },
  isValidPhone(phone) {
    return phone && phone.length >= MIN_PHONE_LENGTH
  }
};
